module.exports = __webpack_public_path__ + "media/src/img/sms_operators-930b9fbc7a57b5c65d5bfce171e30c65.png";